import { useLocation, useNavigate } from "react-router-dom";
import { Home, Briefcase, FileText, User } from "lucide-react";

export default function TelegramBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { to: "/applier/dashboard", label: "Home", icon: Home },
    { to: "/jobs", label: "Jobs", icon: Briefcase },
    { to: "/applier/applications", label: "Applications", icon: FileText },
    { to: "/profile", label: "Profile", icon: User },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };


  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 safe-area-inset-bottom">
      <div className="flex justify-around items-center h-16 max-w-screen-xl mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.to || location.pathname.startsWith(item.to);
          
          return (
            <button
              key={item.to}
              onClick={() => handleNavigation(item.to)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
                isActive
                  ? "text-indigo-600 dark:text-indigo-400"
                  : "text-gray-600 dark:text-gray-400"
              }`}
            >
              <Icon className={`w-6 h-6 ${isActive ? "stroke-2" : "stroke-1"}`} />
              <span className={`text-xs mt-1 ${isActive ? "font-semibold" : "font-normal"}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
